import React from 'react';

const ShoppingBagMono = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.469 46H9.53101C8.96348 46.0001 8.40243 45.8793 7.88514 45.6459C7.36786 45.4124 6.90617 45.0715 6.53076 44.6459C6.15536 44.2203 5.87482 43.7196 5.70779 43.1772C5.54077 42.6348 5.49107 42.0631 5.56201 41.5L9.00001 14H39L42.438 41.5C42.509 42.0631 42.4593 42.6348 42.2922 43.1772C42.1252 43.7196 41.8447 44.2203 41.4693 44.6459C41.0939 45.0715 40.6322 45.4124 40.1149 45.6459C39.5976 45.8793 39.0365 46.0001 38.469 46Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M17 20V9C17 7.14348 17.7375 5.36301 19.0503 4.05025C20.363 2.7375 22.1435 2 24 2V2C25.8565 2 27.637 2.7375 28.9497 4.05025C30.2625 5.36301 31 7.14348 31 9V20"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export default ShoppingBagMono;
